import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';

import { Table } from 'antd';

import { selectJourneyState, selectLoadingState } from '~/store/selectors';
import { getBusinessUnits } from '~/store/fetchActions/fetchJourney';
import { Button } from '~/components';

export default function BusinessUnitsTable() {
  const { businessUnits } = useSelector(selectJourneyState);
  const { isBusinessUnitsLoading } = useSelector(selectLoadingState);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBusinessUnits());
  }, [dispatch]);

  const columns = useMemo(
    () => [
      {
        key: 'name',
        title: 'Nome da Business Unit',
        dataIndex: 'name',
      },
      {
        title: 'Ações',
        align: 'end',
        render: businessUnit => {
          const { id } = businessUnit;
          return (
            <Link
              data-testid={`btn-edit-bu-${id}`}
              key={`btn-edit-bu-${id}`}
              to={`/journey/${id}`}
            >
              <Button type="edit" style={{ marginRight: 12 }} />
            </Link>
          );
        },
      },
    ],
    [],
  );

  return (
    <Table
      dataSource={businessUnits}
      columns={columns}
      loading={isBusinessUnitsLoading}
      data-testid="business-units-table"
      rowKey="id"
    />
  );
}
